/**
 * versicherungsschaeden.js — API-Client für die Schadens-/Dokumenten-App.
 *
 * Spricht /versicherungsschaeden/* Endpunkte an. Pattern wie renameEngine.js.
 */
import { API_BASE } from "./config";

const PREFIX = `${API_BASE}/versicherungsschaeden`;

async function json(method, path, { params, body } = {}) {
  const query = params
    ? "?" +
      new URLSearchParams(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
      ).toString()
    : "";
  const init = { method, headers: {} };
  if (body !== undefined) {
    init.headers["Content-Type"] = "application/json";
    init.body = JSON.stringify(body);
  }
  const res = await fetch(`${PREFIX}${path}${query}`, init);
  const ct = res.headers.get("content-type") || "";
  const data = ct.includes("application/json") ? await res.json() : await res.text();
  if (!res.ok) throw new Error((data && data.detail) || res.statusText);
  return data;
}

export const schaedenApi = {
  list: (filters = {}) => json("GET", "/schaeden", { params: filters }),
  get: (id) => json("GET", `/schaeden/${id}`),
  create: (body) => json("POST", "/schaeden", { body }),
  update: (id, patch) => json("PUT", `/schaeden/${id}`, { body: patch }),
  remove: (id) => json("DELETE", `/schaeden/${id}`),

  addDokument: (schadenId, body) =>
    json("POST", `/schaeden/${schadenId}/dokumente`, { body }),
  uploadDokument: async (schadenId, file, richtung = "eingereicht") => {
    const fd = new FormData();
    fd.append("datei", file);
    fd.append("richtung", richtung);
    const res = await fetch(`${PREFIX}/schaeden/${schadenId}/dokumente/upload`, { method: "POST", body: fd });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.detail || res.statusText);
    return data;
  },
  dokumentDownloadUrl: (dokId) => `${PREFIX}/dokumente/${dokId}/download`,
  updateDokument: (id, patch) => json("PUT", `/dokumente/${id}`, { body: patch }),
  removeDokument: (id) => json("DELETE", `/dokumente/${id}`),
  // Welle 137: Dokumente auswerten (liest nur) und ausgewählte Vorschläge eintragen
  analysieren: (schadenId) => json("POST", `/schaeden/${schadenId}/analysieren`),
  eintragen: (schadenId, body) => json("POST", `/schaeden/${schadenId}/eintragen`, { body }),

  stats: () => json("GET", "/stats"),
  listVersicherungen: (params = {}) => json("GET", "/versicherungen", { params }),
  listObjekte: () => json("GET", "/objekte"),
};
